import GameInfo from "../services/GameInfo.js";

/**
 * Bascule d'une page de jeu vers son écran de fin, et retour.
 *
 * Deux choses changent quand la partie est finie : la consigne « Comment jouer ? »
 * n'a plus lieu d'être, et la largeur de la zone de jeu non plus. Celle-ci est
 * volontairement étroite pour garder les cases de réponse à portée du regard ;
 * l'écran de fin, lui, aligne trois boutons qui n'y tiennent pas et passaient à
 * la ligne alors qu'il restait la moitié de l'écran libre autour.
 */
export function enterEndGame(page) {
    GameInfo.setVisible(false);
    if (page) page.classList.add("is-over");
}

/** Retour au jeu : nouvelle manche, ou retour à la grille des lettres. */
export function leaveEndGame(page) {
    GameInfo.setVisible(true);
    if (page) page.classList.remove("is-over");
}
